import { useField } from "formik";
import {
  InputField,
  EfsMelcoEfsModelsFormat,
  SaveFormButton,
} from "melco-shared-logic";
import { Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Attributes } from "./Attributes";

type PrintLayerDataMappingProps = {
  inputFormat: EfsMelcoEfsModelsFormat;
};

export const PrintLayerDataMapping: React.FC<PrintLayerDataMappingProps> = ({
  inputFormat,
}) => {
  const { t } = useTranslation();

  const [{ value: type }] = useField("config_type");

  if (type !== "Display") {
    return null;
  }

  return (
    <>
      <InputField name="name" label={t("dataMappings.form.label.name")} />

      <Title level={5}>{t(`dataMappings.form.titles.display`)}</Title>

      <Attributes
        dataAssignments={inputFormat.schema_list ?? []}
        attribute="_display"
      />

      <SaveFormButton />
    </>
  );
};
